// ========================================
// HOOK useBlogPosts
// Gestion des articles de blog
// ========================================

import { useState, useEffect, useCallback } from 'react';
import {
  getAllPosts,
  getPostBySlug,
  getRecentPosts,
  addPost,
  updatePost,
  deletePost,
  incrementViews,
  toggleLike
} from '../services/firebase/blogService';
import { toast } from 'react-toastify';

const useBlogPosts = (autoFetch = true, status = null) => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Charger tous les articles
  const fetchPosts = useCallback(async () => {
    setLoading(true);
    setError(null);

    const result = await getAllPosts(status);

    if (result.success) {
      setPosts(result.data);
    } else {
      setError(result.error);
    }

    setLoading(false);
  }, [status]);

  // Charger au montage si autoFetch
  useEffect(() => {
    if (autoFetch) {
      fetchPosts();
    }
  }, [autoFetch, fetchPosts]);

  // Créer un article
  const createPost = async (postData) => {
    const result = await addPost(postData);

    if (result.success) {
      toast.success('Article créé avec succès !');
      await fetchPosts();
      return { success: true, id: result.id };
    } else {
      toast.error('Erreur lors de la création');
      return { success: false, error: result.error };
    }
  };

  // Modifier un article
  const editPost = async (postId, postData) => {
    const result = await updatePost(postId, postData);

    if (result.success) {
      toast.success('Article mis à jour !');
      await fetchPosts();
      return { success: true };
    } else {
      toast.error('Erreur lors de la mise à jour');
      return { success: false, error: result.error };
    }
  };

  // Supprimer un article
  const removePost = async (postId) => {
    const result = await deletePost(postId);

    if (result.success) {
      toast.success('Article supprimé');
      setPosts(prev => prev.filter(p => p.id !== postId));
      return { success: true };
    } else {
      toast.error('Erreur lors de la suppression');
      return { success: false, error: result.error };
    }
  };

  return {
    posts,
    loading,
    error,
    fetchPosts,
    createPost,
    editPost,
    removePost,
    getPostBySlug,
    getRecentPosts,
    incrementViews,
    toggleLike
  };
};

export default useBlogPosts;